var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDaoCategoryProduct = function SvgDaoCategoryProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "social-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 16.521
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108400",
    d: "M0 16.52h20V0H0ZM13.986 3.281a.436.436 0 0 1 .726-.483l3.478 5.217a.442.442 0 0 1 0 .483l-3.478 5.222s-.222.2-.361.2a.408.408 0 0 1-.239-.074.439.439 0 0 1-.122-.6l3.313-4.974ZM7.847 13.337l3.478-10.434a.433.433 0 1 1 .822.274L8.669 13.611a.433.433 0 0 1-.413.3.542.542 0 0 1-.139-.022.434.434 0 0 1-.27-.55ZM1.813 8.02l3.478-5.217a.436.436 0 1 1 .726.483L2.695 8.26l3.317 4.978a.435.435 0 0 1-.122.6.442.442 0 0 1-.239.074.433.433 0 0 1-.361-.2L1.812 8.495a.426.426 0 0 1 0-.483Z"
  })));
};
export default SvgDaoCategoryProduct;